module.exports = __webpack_public_path__ + "img/peco-logo.cafe77af.jpg";